.tile {
    display: flex;
    align-items: center;
    gap: var(--tempest-space-3);
    width: 100%;
    padding: var(--tempest-space-3) var(--tempest-space-4);
    background: var(--tempest-surface);
    color: var(--tempest-text);
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-text-sm);
    text-align: left;
    border: 0;
    border-radius: var(--tempest-radius-md);
}

.interactive {
    cursor: pointer;
    transition: background var(--tempest-duration-fast, 120ms) var(--tempest-ease-out, ease-out);
}

.interactive:hover {
    background: var(--tempest-surface-2);
}

.interactive:focus-visible {
    outline: var(--tempest-focus-ring-width, 2px) solid
        var(--tempest-focus-ring-color, var(--tempest-primary));
    outline-offset: var(--tempest-focus-ring-offset, 2px);
}

.selected {
    background: var(--tempest-primary-soft);
    color: var(--tempest-primary-on-soft);
}

.interactive.selected:hover {
    background: var(--tempest-primary-soft-hover, var(--tempest-primary-soft));
}

.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
}

.leading,
.trailing {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    line-height: 1;
}

.trailing {
    margin-left: auto;
    color: var(--tempest-text-muted);
}

.body {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1 1 auto;
}

.title {
    line-height: var(--tempest-leading-snug, 1.3);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.subtitle {
    color: var(--tempest-text-muted);
    font-size: var(--tempest-text-xs);
    line-height: var(--tempest-leading-snug, 1.3);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.selected .subtitle {
    color: var(--tempest-primary);
    opacity: 0.8;
}
